import {DataFetcher} from '@aboutyou/data-fetcher';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {COLORS, ContentPopperProps} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {RequestFailure} from '../../../../features/Coins/shared/RequestFailure';
import {WalletContentSkeletons} from '../../Skeletons/WalletContentSkeletons';
import {WalletType} from '../../utils/useActiveTab';
import {useGetWallet} from '../../utils/useGetWallet';
import {WalletContentView} from './WalletContentView';

export interface WalletContentProps {
  ref?: React.RefObject<HTMLDivElement | null>;
  activeTab: WalletType;
  onTabClick: (value: WalletType) => void;
  setSelectedProduct?: (product: Product | undefined) => void;
  ContentPopperLayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const WalletContent: React.FC<WalletContentProps> = props => {
  return (
    <DataFetcher
      request={useGetWallet()}
      Error={() => <StyledRequestFailure />}
      Loading={() => <WalletContentSkeletons activeTab={props.activeTab} />}
      View={WalletContentView}
      viewProps={props}
    />
  );
};

const StyledRequestFailure = styled(RequestFailure)`
  padding-top: 8rem;
  height: 100%;
  background-color: ${COLORS.Grey4};
`;
